import { Box } from "@mui/material";
import React from "react";
import FilterItem from "./FilterItem";
import DiscountRewardsFilter from "../../../../../../../media/images/icons/discount-filter";
import StarMedal from "../../../../../../../media/images/icons/star-medal";
import RewardCard from "./RewardCard";

const filters = [
  {
    title: "همه جایزه‌ها",
  },
  {
    title: "کالای دیجیتال",
  },
  {
    title: "کد تخفیف",
    icon: <DiscountRewardsFilter size={16} color="#78909C" />,
  },
  {
    title: "اشتراک ویژه",
    icon: <StarMedal size={20} color="#78909C" />,
  },
];

export default function Rewards() {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          paddingX: "8px",
          overflowX: "auto",
        }}
      >
        {filters.map((item) => (
          <FilterItem title={item.title} icon={item.icon} />
        ))}
      </Box>
      <Box
        sx={{
          mt: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          paddingX: "8px",
        }}
      >
        <RewardCard />
        <RewardCard />
        <RewardCard />
        <RewardCard />
      </Box>
    </Box>
  );
}
